import React from "react";

const SIZE_HEADERS = ["S", "M", "L", "XL", "XXL"];

// Default data — aapke diye gaye 2 charts (INCH & CM). Chahe to yeh
// values yaha se edit kar dena, ya SizeChart ko `inchRows`/`cmRows`
// prop de kar product-wise alag data bhi pass kar sakte ho.
const DEFAULT_INCH_ROWS = [
  ["A- Chest", "36", "38", "40", "42", "44"],
  ["B- Waist", "34", "36", "38", "40", "42"],
  ["C- Hip", "36", "38", "40", "42", "44"],
  ["D- Total Length", "42", "42 1/4", "42 1/2", "42 3/4", "43"],
  ["E- Sleeve Length", "23", "23 1/2", "24", "26 1/2", "25"],
  ["F- Sleeve Opening", "9", "9 1/2", "9 3/4", "10", "10 1/4"],
  ["G- Shoulder", "14", "14 1/2", "15", "15 1/2", "16"],
];

const DEFAULT_CM_ROWS = [
  ["A- Chest", "91.5", "96.5", "101.5", "106.5", "111.5"],
  ["B- Waist", "86.5", "91.5", "96.5", "101.5", "106.5"],
  ["C- Hip", "91.5", "96.5", "101.5", "106.5", "111.5"],
  ["D- Total Length", "107", "107.5", "108", "109", "109.5"],
  ["E- Sleeve Length", "58.5", "60", "61", "62.5", "23.5"],
  ["F- Sleeve Opening", "23", "24", "25", "25.5", "26"],
  ["G- Shoulder", "35.5", "37", "38", "39.5", "41"],
];

function SizeChartTable({ title, rows }) {
  return (
    <div className="size-chart-card">
      <div className="size-chart-card-head">{title}</div>

      <div className="size-chart-scroll">
        <table className="size-chart-table">
          <thead>
            <tr>
              <th>AREA</th>
              {SIZE_HEADERS.map((s) => (
                <th key={s}>{s}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.map((row) => (
              <tr key={row[0]}>
                <td className="size-chart-row-label">{row[0]}</td>
                {row.slice(1).map((val, i) => (
                  <td key={i}>{val}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/**
 * SizeChart — INCH aur CM, dono size charts ek saath (side by side on
 * desktop, stacked + horizontally scrollable on mobile). Theme ke
 * existing "section-segment-heading" style ko follow karta hai.
 */
function SizeChart({ inchRows = DEFAULT_INCH_ROWS, cmRows = DEFAULT_CM_ROWS }) {
  return (
    <div className="size-chart-wrapper">
      {/* <h3 className="section-segment-heading mb-4">Size Guide</h3> */}

      <div className="size-chart-grid">
        <SizeChartTable title="INCH" rows={inchRows} />
        <SizeChartTable title="CM" rows={cmRows} />
      </div>
    </div>
  );
}

export default SizeChart;